import { useEffect, useState } from 'react';
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles, onCellClicked } from './Helpers';
import { checkDoubleImg, crossImg, commentImg, fileKeyImg, resolveImage } from "../../images/ImageResolver";

function transformData(data){
  const rowKeys = ["display","polarity","ratio","currencyDependent","isShare","isPercentage","isAverage","isWholeNumber","description","endpoints","industrial","insurance","bank","property","investment","financial"]
  let tData = data.map(row => ({
    name: row.financialConceptDescription+','+row.financialConceptCode,
    public: "",
    private: row.private,
    advanced: row.advanced,
    professional: row.advanced,
    rowData: rowKeys.map(key => (row[key] ? row[key].replace(/,/g, "") : "")).join(",")
  }))
  return tData
}

function Kpis() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.name.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("KPIs").then((res) => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    if(!wealth){
      grid.addEventListener("click", onCellClicked);
    }
  }, [wealth]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'name', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon },
      { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
      { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon },
      { name: 'dataRow' , field: 'rowData', visible: false}
    ]

    let onRowExpansionBinding = function(e) {
      let rowData = e.originalRowData;
      let data = rowData ? rowData["rowData"].split(',') : [];
      let rowIndex = e["rowIndex"];
      let section = e["section"];
      let cell = section.stretchCell(0, rowIndex, true);
      let items = ["Industrial", "Insurance", "Bank", "Property", "Investment", "Financial"];
      let indiItems = [
        {"display": data[0] },
        {"polarity": data[1] },
        {"Ratio": data[2] },
        {"Currency Dependent": data[3] },
        {"Is Share": data[4] },
        {"Is Percentage": data[5] },
        {"Is Average": data[6] },
        {"Is Whole Number": data[7] }
      ]
      if (e.rowExpansion && rowData) {
        // render
        cell.setStyle("backgroundColor", "#FFFFF");
        section.setRowHeight(rowIndex, 560); // Customized height

        let expContent = cell.getContent();
        if (!expContent || !expContent._myExpansion) {
          expContent = document.createElement("div");
          expContent._myExpansion = true;

          let firstLine = expContent._firstLine = document.createElement("ef-layout");
          firstLine.style.display = "flex";
          let desc = expContent._desc = document.createElement("ef-layout");
          desc.style.display = "flex";
          desc.style.marginTop = "20px";
          desc.style.paddingLeft = "5px";
          let secondLine = expContent._secondLine = document.createElement("ef-layout");
          secondLine.style.display = "flex";
          secondLine.style.paddingBottom = "10px";
          let thridLine = expContent._thirdLine = document.createElement("ef-layout");
          thridLine.style.paddingLeft = "5px";
          thridLine.style.marginTop = "10px";

          items.forEach((item, i) => {
            let cLayout = document.createElement("ef-layout");
            cLayout.style.fontWeight = "600";
            cLayout.style.backgroundColor = "#fafaff";
            cLayout.style.color = "#0d0d0d";
            cLayout.style.border = "1px solid #e6e6e6";
            cLayout.style.padding = "15px 20px";
            cLayout.style.margin = "10px 5px";
            cLayout.style.borderRadius = "6px";
            cLayout.style.fontSize = "14px";
            // cLayout.style.height = "49px";
            let iconImg = document.createElement("img");
            if (data[10 + i] === "x") {
              iconImg.src = checkDoubleImg;
            }else {
              iconImg.src = crossImg;
            }
            iconImg.style.marginRight = "10px";
            cLayout.appendChild(iconImg);
            let pillText = document.createElement("span");
            pillText.textContent = item;
            cLayout.appendChild(pillText);
            let iconImg2 = document.createElement("img");
            iconImg2.src = resolveImage(item);
            iconImg2.style.float = "right";
            iconImg2.style.marginLeft = "10px";
            cLayout.appendChild(iconImg2);
            firstLine.appendChild(cLayout);
          });

          let descImage = document.createElement("img");
          descImage.src = commentImg;
          descImage.style.marginRight = "10px";
          descImage.style.width = "24px";
          descImage.style.height = "24px";
          desc.appendChild(descImage);
          let descText = document.createElement("h2");
          descText.textContent = "Description";
          descText.style.fontWeight = "600";
          descText.style.fontSize = "16px";
          descText.style.color = "#001eff";
          descText.style.margin = "0px";
          desc.appendChild(descText);

          let descLayout = document.createElement("ef-layout");
          descLayout.style.width = "60%";
          descLayout.style.fontWeight = "400";
          descLayout.style.backgroundColor = "transparent";
          descLayout.style.color = "#666666";
          descLayout.style.border = "none";
          descLayout.style.padding = "10px 30px 10px 0px";
          descLayout.style.margin = "10px 5px";
          descLayout.style.fontSize = "16px";
          descLayout.style.whiteSpace = "pre-line";
          descLayout.innerHTML = data[8];
          secondLine.appendChild(descLayout);

          let indiLayout = document.createElement("ef-layout");
          indiLayout.style.fontWeight = "400";
          indiLayout.style.backgroundColor = "#f8f8f8";
          indiLayout.style.color = "#1a1a1a";
          indiLayout.style.border = "none";
          indiLayout.style.padding = "10px 20px";
          indiLayout.style.margin = "10px 5px";
          indiLayout.style.fontSize = "16px";

          indiItems.forEach((item, i) => {
            let indiDiv = document.createElement("div");
            indiDiv.style.marginBottom = "10px";
            indiDiv.style.textTransform = "capitalize";
            let indiText = document.createElement("span");
            indiText.style.display = "inline-block";
            indiText.style.marginTop = "5px";
            indiText.innerHTML = Object.keys(item);
            indiDiv.appendChild(indiText);
            let indiPill = document.createElement("ef-pill");
            indiPill.style.fontWeight = "400";
            const val = String(Object.values(item)).toLowerCase(); 
            if (val === "positive" || val === "yes") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            } else if (val === "negative" || val === "no") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            } else if (val === "1") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = "Yes";
            } else if (val === "0") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = "No";
            } else {
              indiPill.style.backgroundColor = "#e8e8e8";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            }
            indiPill.style.border = "none";
            indiPill.style.padding = "14px 20px";
            indiPill.style.margin = "5px 15px";
            indiPill.style.borderRadius = "20px";
            indiPill.style.float = "right";
            indiPill.style.fontSize = "14px";
            indiPill.style.fontWeight = "400";
            indiPill.style.minWidth = "90px";
            indiDiv.appendChild(indiPill);
            indiLayout.appendChild(indiDiv);
          });
        
          secondLine.appendChild(indiLayout);

          let endpointLabel = document.createElement("label");
          let endpointInput = document.createElement("ef-text-field");
          endpointLabel.textContent = "Endpoint:";
          endpointLabel.style.fontWeight = "600";
          endpointLabel.style.marginRight = "0px";
          endpointLabel.style.color = "#334d6e";
          endpointLabel.style.fontSize = "16px";
          endpointLabel.style.height = "42px";
          endpointLabel.style.padding = "10px 20px 14px 20px";
          endpointLabel.style.backgroundColor = "#e8e8e8";
          endpointLabel.style.border = "1px solid #e8e8e8";
          endpointInput.value = data[9];
          endpointInput.style.width = "60%";
          endpointInput.style.padding = "10px 20px";
          endpointInput.readOnly = true;
          endpointInput.style.color = "#334d6e";
          endpointInput.style.fontSize = "14px";
          endpointInput.style.border = "1px solid #e8e8e8";
          endpointInput.style.height = "40px";
          thridLine.appendChild(endpointLabel);
          thridLine.appendChild(endpointInput);

          expContent.appendChild(firstLine);
          expContent.appendChild(desc);
          expContent.appendChild(secondLine);
          expContent.appendChild(thridLine);
        }

        rowData = e.originalRowData;
        cell.setContent(expContent);
      } else {
        // dispose
        cell = section.stretchCell(0, rowIndex, false);
        cell.setStyle("backgroundColor", "");
        section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
      }
    }

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        let rowData = e.data.split(",");
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineIcon = document.createElement("ef-icon");
        let firstLineText = document.createElement("span");
        firstLineIcon.icon = "right";
        firstLineIcon.style.marginRight = "10px";
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine._firstLineIcon = firstLineIcon;
        firstLine.appendChild(firstLineIcon);
        firstLineText.textContent = rowData[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        let secondLine2 = document.createElement("ef-pill");
        let secondLine22 = document.createElement("span");
        let secondLine2Icon = document.createElement("img");
        secondLine2Icon.src = fileKeyImg;
        secondLine2Icon.style.marginRight = "5px";
        secondLine2Icon.style.marginTop = "5px";
        secondLine22._secondLine2Icon = secondLine2Icon;
        secondLine22.appendChild(secondLine2Icon);
        secondLine2.style.fontWeight = "400";
        secondLine2.style.backgroundColor = "transparent";
        secondLine2.style.color = "#999999";
        secondLine2.style.border = "none";
        secondLine22.textContent = rowData[1];
        secondLine22.style.fontSize = "14px";
        secondLine22.style.display = "inline-flex";
        secondLine22.style.verticalAlign = "super";
        secondLine2.appendChild(secondLine2Icon);
        secondLine2.appendChild(secondLine22);
        content._secondLine2 = secondLine2;
        content.appendChild(secondLine2);

        content.addEventListener("click", function() {
          if (firstLineIcon.icon === "right") {
            firstLineIcon.icon = "down";
          } else {
            firstLineIcon.icon = "right";
          }
        });
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    if(!wealth){
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData,
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
          colIndex: 0,
          sortOrder: "a"
          },
        },
        rowExpansionBinding: onRowExpansionBinding
      };
    }
  }, [fullData, searchData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div id='loadingMask_div'>
          <h4>Operating Metrix - KPIs</h4>
          <p>This is a complete list of available Key Performance Indicators (KPIs) or Operating Metrix available per customer use case and package.</p>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}

export default Kpis;
